import React, { useState } from "react";
import { Spinner } from "react-bootstrap";
import Modal from "react-bootstrap/Modal";
import {FaBook, FaBookOpen, FaCoins, FaUser, FaClock, FaFilter} from "react-icons/fa";

const InfoAssUnderBookS2 = ({ show, handleClose, assignment }) => {
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState("");

    const date = new Date(assignment.start_read_date * 60 * 1000);

    // минуты -> миллисекунды (безопасно)
    const minutesToMs = (m) => (Number.isFinite(m) ? m * 60 * 1000 : NaN);

    // 1) Длинная дата + короткое время. По умолчанию en-GB (24h).
// Для AM/PM можно вызвать с { locale: 'en-US' }.
    const formatDateLongFromMinutes = (
        minutes,
        {
            locale = 'en-GB',
            timeZone = Intl.DateTimeFormat().resolvedOptions().timeZone,
        } = {}
    ) => {
        const ms = minutesToMs(minutes);
        if (!Number.isFinite(ms)) return 'N/A';
        const d = new Date(ms);
        try {
            return new Intl.DateTimeFormat(locale, {
                dateStyle: 'long',  // e.g. "12 June 2025"
                timeStyle: 'short', // e.g. "22:15"
                timeZone,
            }).format(d);
        } catch {
            return d.toLocaleString(locale, { timeZone });
        }
    };

// 2) Длительность между двумя моментами (в минутах) => "Xd, YH, ZM"
    const formatDurationBetweenMinutes = (
        startMinutes,
        endMinutes = Math.floor(Date.now() / (60 * 1000))
    ) => {
        const s = minutesToMs(startMinutes);
        const e = minutesToMs(endMinutes);
        if (!Number.isFinite(s) || !Number.isFinite(e)) return 'N/A';

        const diffMs = Math.max(0, e - s);
        const totalMin = Math.floor(diffMs / (1000 * 60));
        const d = Math.floor(totalMin / (60 * 24));
        const h = Math.floor((totalMin % (60 * 24)) / 60);
        const m = totalMin % 60;
        return `${d}D, ${h}H, ${m}M`;
    };

// 3) Синоним: «сколько прошло с момента»
    const formatElapsedFromMinutes = (startMinutes) =>
        formatDurationBetweenMinutes(startMinutes);

    // ✅ Полные названия месяцев
    const months = [
        "January", "February", "March", "April", "May", "June",
        "July", "August", "September", "October", "November", "December"
    ];

    // ✅ Получаем дату начала чтения
    const month = months[date.getMonth()];
    const day = date.getDate();
    const year = date.getFullYear();
    const hours = date.getHours();
    const minutes = date.getMinutes();
    const formattedMinutes = minutes < 10 ? `0${minutes}` : minutes;
    const formattedHours = hours < 10 ? `0${hours}` : hours;

    // ✅ Вычисляем, сколько времени прошло с момента начала чтения
    const now = new Date();
    const elapsedTime = now - date;
    const elapsedMinutes = Math.floor(elapsedTime / (1000 * 60));
    const elapsedHours = Math.floor(elapsedMinutes / 60);

    return (
        <Modal show={show} onHide={() => { setError(""); handleClose(); }} top>
            <div className="modal-content">
                <div className="modal-header small" style={{height:40}}>
                    <h6 className="modal-title fs-6">Assignment: #{assignment?.bookId}-{assignment?.id}</h6>
                    <button
                        type="button"
                        className="btn-close"
                        aria-label="Close"
                        onClick={() => {
                            setError("");
                            handleClose();
                        }}
                    ></button>
                </div>

                <div className="modal-body small">
                    <p
                        className=" mb-1 fs-6 mt-0 text-muted"
                   >
                        <FaBookOpen className="me-1   fa-beat" /> {/* ✅ Анимированная иконка */}

                    <strong className="  m-1">Participant start working...</strong>
                    </p>



                    {/* Posted */}
                    {assignment?.start_rev_date && (
                        <p className="me-2 mb-1 mt-0 text-muted" style={{ lineHeight: "1.2" }}>
                            <FaBook className="me-2" />
                            Posted: <strong>{formatDateLongFromMinutes(assignment?.start_rev_date)}</strong>
                        </p>
                    )}

                    {/* Start Reading */}
                    {assignment?.start_read_date && (
                        <p className="me-2 mb-1 mt-0 text-muted" style={{ lineHeight: "1.2" }}>
                            <FaBookOpen className="me-2" />
                            Start: <strong>{formatDateLongFromMinutes(assignment?.start_read_date)}</strong>
                        </p>
                    )}
                    {assignment?.start_read_date && (
                        <p className="me-2 mb-1 mt-0 text-muted" style={{ lineHeight: "1.2" }}>
                            <FaClock className="me-2  " />
                            Time:{" "}
                            <strong>
                                {formatElapsedFromMinutes(assignment?.start_read_date)}
                            </strong>
                        </p>
                    )}
                    <p className="mb-1 mt-0 text-muted">
                        <FaBook className="me-2 mb-0 mt-0 text-muted" />
                        Assignment for:
                        <strong className="  m-1">
                            {(() => {
                                switch (assignment?.booksTypeId) {
                                    case 1: return "Book in Kindle,";
                                    case 2: return "Book in Paperback,";
                                    case 3: return "Book in Hardcover,";
                                    case 4: return "Audiobook,";
                                    case 5: return "Boost Existing Review,";
                                    case 6: return "Report Existing Review,";
                                    case 7: return "Physical Product,";
                                    case 8: return "Physical Product,";
                                    case 9: return "Physical Product,";
                                    case 10: return "Physical Product,";
                                    default:
                                        return "N/A";
                                }
                            })()}
                        </strong>
                    </p>

                    <p className="me-2 mb-1 mt-0 text-muted" style={{ lineHeight: "1.2" }}>
                        <FaBook className="me-2" />
                        Type:{" "}
                        <strong className="  m-0">
                            {(() => {
                                switch (assignment.assTypeId) {
                                    case 1: return "Universal Assignment";
                                    case 2: return "Kindle Unlimited";
                                    case 3: return "Kindle Verified Purchase";
                                    case 4: return "Kindle Verified Purchase + Img";
                                    case 5: return "Kindle Verified Purchase Search&Buy";
                                    case 6: return "Kindle Verified Search&Buy + Img";
                                    case 7: return "Universal Assignment for Audio";
                                    case 8: return "Audible Promo Code Assignment";
                                    case 9: return "Verified Kindle Unlimited";
                                    case 10: return "Paperback BuyOut";
                                    case 11: return "Paperback Search&BuyOut";
                                    case 12: return "Paperback Verified Purchase + Img";
                                    case 13: return "Paperback Verified Purchase + Video";
                                    case 14: return "HC BuyOut";
                                    case 15: return "HC Search&BuyOut";
                                    case 16: return "HC Verified Pur. + Img";
                                    case 17: return "HC Verified + Video";
                                    case 18: return "PB Verified Purchase";
                                    case 19: return "PB Verified Purchase Search&Buy";
                                    case 20: return "HC Verified Purchase";
                                    case 21: return "HC Verified Purchase Search&Buy";
                                    case 22: return "Product BuyOut";
                                    case 23: return "Product Search&BuyOut";
                                    case 24: return "Product Verified Purchase";
                                    case 25: return "Product Verified + Img";
                                    case 26: return "Product Verified + Vid";
                                    case 27: return "Product VP Search&Buy";
                                    case 28: return "Make Helpful Internal";
                                    case 29: return "Write Report Internal";
                                    case 30: return "Make Helpful External";
                                    case 31: return "Write Report External";
                                    case 32: return "Set Stars Rating";
                                    default:
                                        return "Unknown Type"; // ✅ Защита от неверных значений
                                }
                            })()}
                        </strong>
                    </p>

                    <p className="me-2 mb-1 mt-0 text-muted" style={{ lineHeight: "1.2" }}>
                        <FaCoins className="me-2" />
                        Reward / Cost: <strong className="m-0">{assignment.assignment_price_publisher || "Unknown"}</strong> Virt /
                        <b className="text-danger">
                            {[10,11,12,13,14,15,16,17,18,19,20,21,22,23,24,25,26,27].includes(assignment?.assTypeId) ? (
                                assignment?.assignment_price_publisher
                                    ? ` $${assignment.book_cost_compensation}`
                                    : "N/A"
                            ) : (
                                (() => {
                                    let priceLabel;
                                    switch (assignment?.booksPriceId) {
                                        case 1: priceLabel = " Free"; break;
                                        case 2: priceLabel = " $0.99"; break;
                                        case 3: priceLabel = " $1.99"; break;
                                        case 4: priceLabel = " $2.99"; break;
                                        case 5: priceLabel = " $3.99"; break;
                                        case 6: priceLabel = " $4.99"; break;
                                        case 7: priceLabel = " $5.99"; break;
                                        case 8: priceLabel = " $6.99"; break;
                                        case 9: priceLabel = " $7.99"; break;
                                        case 10: priceLabel = " $8.99"; break;
                                        case 11: priceLabel = " $9.99"; break;
                                        default: priceLabel = " Unknown Type";
                                    }

                                    // Добавляем " Promo" при нужных условиях
                                    if (assignment?.booksPriceId === 1 && [3, 4, 5, 6, 32].includes(assignment?.assTypeId)) {
                                        priceLabel += " Promo";
                                    }

                                    return priceLabel;
                                })()
                            )}




                        </b>

                    </p>

                    <p className="me-2 mb-1 mt-0 text-muted" style={{ lineHeight: "1.2" }}>
                        <FaUser className="me-2" />
                        Participant: <strong className="  m-0">"{assignment.reviewer_name || "Unknown"}"</strong>
                    </p>
                    <p className="me-2 mb-1 mt-0 text-muted" style={{ lineHeight: "1.2" }}>
                        <FaFilter className="me-2" />
                        Country:
                        <b>
                            {(() => {
                                switch (assignment.assignment_prefer_country) {
                                    case "https://www.amazon.com":
                                        return " USA";
                                    case "https://www.amazon.ca":
                                        return " Canada";
                                    case "https://www.amazon.com.au":
                                        return " Australia";
                                    case "https://www.amazon.co.uk":
                                        return " United Kingdom";
                                    case "https://www.amazon.de":
                                        return " Deutschland";
                                    case "https://www.amazon.fr":
                                        return " France";
                                    case "https://www.amazon.it":
                                        return " Italia";
                                    case "https://www.amazon.es":
                                        return " España";
                                    case "https://www.amazon.in":
                                        return " India";
                                    case "https://www.amazon.co.jp":
                                        return " Japan";
                                    case "https://www.amazon.com.br":
                                        return " Brasil";
                                    case "https://www.amazon.nl":
                                        return " Netherlands";
                                    case "https://www.amazon.com.mx":
                                        return " Mexico";
                                    case "https://www.amazon.sg":
                                        return " Singapore";
                                    case "https://www.amazon.cn":
                                        return " China";
                                    default:
                                        return " All";
                                }
                            })()}</b>
                        {assignment?.rating_of_reviewer > 20 && (
                            <span className="ms-0 fw-semibold text-success">
                                        {" "}/ Quality: {assignment.rating_of_reviewer}%
                                     </span>
                        )}
                    </p>
                </div>

                <div
                    className="modal-footer d-flex align-items-center justify-content-end px-2"
                    style={{ height: 50, paddingTop: 0, paddingBottom: 0 }}
                >
                    <button
                        type="button"
                        className="btn btn-sm btn-secondary"
                        onClick={() => {
                            setError("");
                            handleClose();
                        }}
                        disabled={loading}
                    >
                        Close
                    </button>
                </div>

            </div>
        </Modal>
    );
};

export default InfoAssUnderBookS2;
